import { Injectable } from "@angular/core";
import { IID_RISORSE_IRU_ACQUISIZIONE } from "@common/interfaces/interfaceData";
import { AbstractInterfaceDataQuery } from "@ep-om/project/state/interfaceDataModel";
import { IIDRisorseIruAcquisizioneStore } from "./iidRisorseIruAcquisizione.store";
import { InterfaceDataQuery } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

@Injectable({
  providedIn: 'root'
})
@InterfaceDataQuery(InterfaceName.RISORSE_IRU_ACQUISIZIONE)
export class IIDRisorseIruAcquisizioneQuery extends AbstractInterfaceDataQuery<IID_RISORSE_IRU_ACQUISIZIONE> {
  constructor(protected store: IIDRisorseIruAcquisizioneStore) {
    super(store);
  }
}
